import { SearchBy } from "../Enum/Enum";

export class IdViewModel {
    searchDate: string;
    fromPortIds: string;
    toPortIds: string;
    searchBy: SearchBy;
    pageNo: number;
    recPerPage: number;
    ShippingLineIds: string;
    toPortArrivalDate: string;
    fromPortArrivalDate: string;
    vesselsId: number;    
    userDetailsId: number;
    isBasicSearch: string;
    toVesselsId: number;
    midPortId: number;
    cubicMeter:number;
    transhipment:number;
    FromCountryId:number;
    ToCountryId:number;
}